<div class="heading heading_small">
  <img
    src="assets/icon-invoice.svg"
    width="110"
    height="104"
    alt="Invoices icon"
  />
  Invoices
</div>
@if ({ invoices: invoices$ | async }; as asyncResult) {
  @if (asyncResult.invoices && asyncResult.invoices.length > 0) {
    <div class="table table_inline border-radius">
      @for (
        invoice of partialView
          ? asyncResult.invoices.slice(0, 6)
          : asyncResult.invoices;
        track invoice.id
      ) {
        <app-invoice-item [invoice]="invoice"></app-invoice-item>
      }
      @if (partialView) {
        @if (asyncResult.invoices.length > 6) {
          <div class="account__more">
            <a routerLink="invoices" class="button button_dark button_standard">
              All invoices
            </a>
          </div>
        }
      } @else {
        @if (hasMoreResults$ | async) {
          <app-gallery-items-load-more (loadMore)="onLoadMore()" />
        }
      }
    </div>
  } @else {
    <app-empty-block title="You have no available invoices.">
      <p>
        At the moment, you have not made any purchases, so you have no available
        invoices.
      </p>
      <p>
        Explore our extensive selection of stock videos in our database and find
        the perfect high-quality content for yourself.
      </p>
    </app-empty-block>
  }
}
